import React, {useState} from 'react';
import './AccordionForums.scss';
import {Collapse} from 'reactstrap';


const AccordionForums = ({isOpenDefaultValue = true, title = '', children}) => {
    const [isOpen, setIsOpen] = useState(isOpenDefaultValue);

    const toggle = () => setIsOpen(!isOpen);

    return (
        <div className={`app-bg-gray font-weight-bold mb-4 accordionforums ${isOpen && 'accordionforums-active'}`} onClick={toggle}>
            <div className="d-flex justify-content-between">
                <div className={`accordionforums-title ${isOpen ? 'font-weight-bold' : ''}`}>{title}</div>
                <div className="accordionforums-sign">
                {isOpen ?
                    <img style={{width:'20px', height: '15px'}} src={require('../../assets/images/arrowacc1.png')}/>
                    : <img style={{width:'20px', height: '15px'}} src={require('../../assets/images/arrowacc2.png')}/>}
                </div>
            </div>
            <Collapse isOpen={isOpen} className="ml-3">
                { children }
            </Collapse>
        </div>
    );
}

export default AccordionForums;